import DashboardComponent from "../../modules/dashboard/dashboard";

export default function Dashboard() {
  return <DashboardComponent role="user" />;
}